import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFire = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M10 18.25c4 0 6.75-3 6.75-6.5 0-2.25-1.25-3.75-3-4.995C13.5 8 12.5 9.5 10.75 10.25 12 8 12.5 4.5 8.75 1.75 8.723 2.583 8 4.5 6 6.5s-2.75 3-2.75 5.25c0 3.5 2.75 6.5 6.75 6.5Z"
	})]
});
const ForwardRef = forwardRef(SvgFire);
export { ForwardRef as ReactComponent };
